module.exports = __webpack_public_path__ + "static/media/29-verdt.f30d7c21.mp3";